import { useSyncExternalStore } from "react";

import type { WorkspaceConfig } from "@storyboard/web-client";
import { getWorkspaceConfig, subscribeWorkspaceConfigs } from "@/data/workspaceConfig";

/**
 * A workspace's compiled config, re-read whenever it changes.
 *
 * Subscribes to the config store itself: a config-only change leaves the store's `workspace` row untouched, so a
 * component that reads `getWorkspaceConfig` at render time never sees it. The snapshot is the stored object, which
 * `updateWorkspaceConfig` keeps across an equal refetch, so an unchanged config does not re-render the caller.
 */
export function useWorkspaceConfig(workspaceId: string | undefined): WorkspaceConfig | undefined {
  return useSyncExternalStore(subscribeWorkspaceConfigs, () =>
    workspaceId ? getWorkspaceConfig(workspaceId) : undefined,
  );
}
